import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/dashboard/DashboardPage';
import {
	DEFAULT_PERIOD,
	dashboardParamsSchema,
} from '@/features/dashboard/period';

export const Route = createFileRoute('/_app/dashboard')({
	validateSearch: dashboardParamsSchema,
	component: DashboardRoute,
});

function DashboardRoute() {
	const { period = DEFAULT_PERIOD } = Route.useSearch();
	const navigate = Route.useNavigate();
	return (
		<DashboardPage
			period={period}
			onPeriodChange={(next) => void navigate({ search: { period: next } })}
		/>
	);
}
